const Followsection = () => {
    return <>
    <div className="follow-section mt-4"  id="followsection">
    <div className="container">
      <div className="row">
        <div className="col-12 text-center">
          <h1> Follow Us </h1>
        </div>
        <div className="col-12 d-flex flex-row justify-content-center">
          <div className="icon-container">
            <i className="fa-brands fa-twitter icon-design"></i>
          </div>
          <div className="icon-container">
            <i className="fa-brands fa-instagram icon-design"></i>
          </div>
          <div className="icon-container">
            <i className="fa-brands fa-facebook icon-design"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

    </>
}

export default Followsection